The questionnaire choice for the answer.

For `FreeText` questions this will be `null`.
